/** The audit log's filter toolbar, in the columns' order, and the Local / UTC switch. */

import { DateFilter } from '@/ui/DateFilter';
import { MultiSelect } from '@/ui/MultiSelect';

import { outcomePill } from './outcomePill';
import { SourceIpFilter } from './SourceIpFilter';
import type { AuditLogState } from './useAuditLogState';

const options = (values: string[] | undefined, label: (v: string) => string = (v) => v) =>
  (values ?? []).map((v) => ({ value: v, label: label(v) }));

const outcomeLabel = (o: string) => outcomePill(o).label;

export function AuditFilterBar({ state }: { state: AuditLogState }) {
  const { facets, values, set, utc, setUtc } = state;
  return (
    <div className="toolbar filter-panel audit-filters">
      <DateFilter value={values.date} utc={utc} onChange={set.date} />
      <MultiSelect
        label="Filter by actor"
        allLabel="All actors"
        noun="actors"
        searchable
        options={options(facets?.actors)}
        value={values.actors}
        onChange={set.actors}
      />
      <MultiSelect
        label="Filter by action"
        allLabel="All actions"
        noun="actions"
        searchable
        options={options(facets?.actions)}
        value={values.actions}
        onChange={set.actions}
      />
      <MultiSelect
        label="Filter by entity"
        allLabel="All entities"
        noun="entities"
        options={options(facets?.entity_types)}
        value={values.entityTypes}
        onChange={set.entityTypes}
      />
      <MultiSelect
        label="Filter by outcome"
        allLabel="All outcomes"
        noun="outcomes"
        options={options(facets?.outcomes, outcomeLabel)}
        value={values.outcomes}
        onChange={set.outcomes}
      />
      <SourceIpFilter value={values.sourceIp} onChange={set.sourceIp} />
      <div className="segmented" role="radiogroup" aria-label="Traced reads">
        <button type="button" role="radio" aria-checked={!values.traced} onClick={() => set.traced(false)}>Hide traced reads</button>
        <button type="button" role="radio" aria-checked={values.traced} onClick={() => set.traced(true)}>Show traced reads</button>
      </div>
      {state.filtered && (
        <button type="button" className="btn btn-ghost" onClick={state.clear}>Clear filters</button>
      )}
      <div className="spacer" />
      <div className="segmented" role="radiogroup" aria-label="Show times in">
        <button type="button" role="radio" aria-checked={!utc} onClick={() => setUtc(false)}>Local</button>
        <button type="button" role="radio" aria-checked={utc} onClick={() => setUtc(true)}>UTC</button>
      </div>
    </div>
  );
}
